@if (thouShallNotPass) {
  <h1>
    No access.
  </h1>
}
@if (thereMayBeErrors) {
  <h1>
    There was an Error during login. Please contact CST.
    {{TheError}}
  </h1>
}
@if (noLicence) {
  <h1>
    You have no licence to access this page.
  </h1>
}
